var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sac"},[_c('NavBar'),_c('h1',[_vm._v("Sac de l'explorateur")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }